export default "__VITE_ASSET__Db7UzrzZ__"